<div mat-dialog-title>
  <h2>{{ 'download_files_title' | locale }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon> close </mat-icon>
  </button>
</div>

<mat-dialog-content>
  <app-call-files-list
    [prescriptions]="prescriptions"
    [medicalOrders]="medicalOrders"
    [medicalCareRecord]="medicalCareRecord"
    [instructions]="instructions"
    [urls]="urls"
  >
  </app-call-files-list>
</mat-dialog-content>
